<script setup lang="ts">
import {useDataStore} from "~/composables/stores/data.store";
import {useHttpStore} from "~/composables/stores/http.store";
import {useDark} from "@vueuse/core";
import LanguageSwitcher from "~/components/common/languageSwitcher.vue";
import SeoSetter from "~/components/common/SeoSetter.vue";
import Analytics from "~/components/common/analytics.vue";
import {vAutoAnimate} from '@formkit/auto-animate'
import type {languagesCommon} from "~~/schemas/main.schema.dto";


let data = useDataStore()
let http = useHttpStore()
const {locale, t} = useI18n()
let isDark = useDark()
let toggleDark = useToggle(isDark)

let lang = computed(() => locale.value as unknown as languagesCommon)
const localePath = useLocalePath()

let cartIsOpen = ref(false)

// main data fetch
await useAsyncData('getDomainGroupDefault', async () => {
  const domainGroupObj = await http.getDomainGroup()
    http.domainGroupObj = domainGroupObj
  return domainGroupObj
}, {deep: true,})


// await useAsyncData('AllPatternsCache', () => {
//   return http.getAllPatternsCache()
// }, {deep: true})
// await useAsyncData('AllPatterns', () => {
//   return http.getAllPatterns()
// }, {deep: true, server: false})
//
// if (!data.cartId) {
//   await useAsyncData('NewCart', () => {
//     return http.getNewCartData()
//   }, {deep: true})
// }
//
// await useAsyncData('shippingCost', () => {
//   return http.getShippingCostData()
// }, {deep: true})
//
// await useAsyncData('Cart', () => {
//   return http.getCartData(data.cartId)
// }, {deep: true, server: false})
//
// // have to rerun localePath() on locale change
// watch(locale, () => {
//   setLinks()
//   setTypesLinks()
// })

let menuIsOpen = ref(false)
let links = ref([
  [
    {
      label: 'Guide',
      icon: 'i-lucide-book-open',
      to: '/getting-started'
    },
    {
      label: 'Composables',
      icon: 'i-lucide-database',
      to: '/composables'
    },
    {
      label: 'Components',
      icon: 'i-lucide-box',
      to: '/components',
      active: true
    }
  ],
  [
    {
      label: 'GitHub',
      icon: 'i-simple-icons-github',
      badge: '3.8k',
      to: 'https://github.com/nuxt/ui',
      target: '_blank'
    }
  ]
])

// function setLinks() {
//   links.value = [{
//     label: 'home',
//     to: '/',
//     icon: 'i-heroicons-home',
//     click: () => menuIsOpen.value = false
//   },]
// }

// setLinks()

// function setTypesLinks() {
//   let typesArray = []
//   for (let clotheType of data.allTypes) {
//     typesArray.push({
//       label: capitalizeFirstLetterOfEachWord(clotheType.name[lang.value]),
//       icon: '',
//       to: localePath({name: 'type-types', params: {type: clotheType.name[lang.value]}}),
//       click: () => menuIsOpen.value = false
//     })
//   }
//   typesLinks.value = typesArray
// }

// setTypesLinks()

</script>


<template>
  <SeoSetter></SeoSetter>
  <analytics></analytics>

  <USlideover side="left" v-model:open="menuIsOpen">
     <template #content>
       <UNavigationMenu orientation="vertical" :items="links" class="data-[orientation=vertical]:w-48"/>
     </template>
  </USlideover>

<!--  <USlideover side="right" v-model="cartIsOpen">/>-->
<!--    &lt;!&ndash;    <Cart v-model:menu-is-open="cartIsOpen"></Cart>&ndash;&gt;-->
<!--  </USlideover>-->

  <div class="sticky top-0 z-10 flex justify-between bg-gray-50 topBar dark:bg-gray-900">
    <div class="sectionLeft flex items-center  justify-center align-center cursor-pointer" v-auto-animate
         @click="menuIsOpen=true">
      <UIcon name="line-md:menu" class=" h-12 w-12 text-primary"/>
      <div class="">Menu</div>
    </div>
    <div class="flex items-center justify-end sectionRigth">
      <UPopover mode="click">
        <UIcon :name="'i-material-symbols-language'" class="h-12 w-12 cursor-pointer text-primary"></UIcon>
        <template #content>
          <LanguageSwitcher></LanguageSwitcher>
        </template>
      </UPopover>
      <div class="m-4 darkModeSwitcher">
        <client-only>
          <UIcon v-if="isDark" name="i-wpf-sun" class="h-12 w-12 cursor-pointer text-primary"
                 @click="toggleDark()"/>
          <UIcon v-else name="i-line-md-moon-alt-loop" class="h-12 w-12 cursor-pointer text-primary"
                 @click="toggleDark()"/>
        </client-only>
        <!--        <UChip :text="data.cart.length" size="2xl" class="mx-2">-->
        <!--          <UIcon :name="'i-mdi-cart'" class="h-12 w-12 cursor-pointer text-primary" @click="cartIsOpen=true"></UIcon>-->
        <!--        </UChip>-->
      </div>
    </div>
  </div>
  <div class="logo-grid">
    <div></div>
    <!--    <img class="" src="/logo.png" alt="logo" @click="navigateTo(localePath('/'))"/>-->
    <div></div>
  </div>
  <p class="text-center text-primary">{{ $t('welcomeBanner') }}</p>

  <div style="min-height: 50vh">
    <slot/>
  </div>


  <!--  <Footer></Footer>-->
</template>

<style scoped lang="postcss">


.logo-grid {
  display: grid;
  grid-template-columns: minmax(0, 4fr) 10fr minmax(0, 4fr);
  max-height: 10vh;
  justify-items: center;

  img {
    aspect-ratio: 388 / 200;
    max-height: 10vh;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 11;
  }
}
</style>
